import React from 'react';
import uuid from 'uuid-random';
import { VisibilityState } from '../../../types';
import { StyledContainer } from '../../Styled';

interface IButton {
  content: JSX.Element;
  onClick?: (id: string) => void;
  onKeyDown?: (id: string) => void;
  sectionId: string;
  visibility: VisibilityState;
  isAccessible: boolean;
  color?: string;
}

export const ContainerButton = (props: IButton): JSX.Element => {
  const { content, onClick, sectionId, visibility, isAccessible, color } = props;

  const handleClick = () => {
    onClick && onClick(sectionId);
  };

  const handleKeyDown = (event: React.KeyboardEvent): void => {
    event.key === 'Enter' && onClick && onClick(sectionId);
  };

  return (
    <StyledContainer
      data-testid="text-button"
      role="button"
      tabIndex={0}
      key={uuid()}
      visibility={visibility}
      isAccessible={isAccessible}
      color={color}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      {content}
    </StyledContainer>
  );
};
